import React, { useContext, useEffect } from 'react';
import {
  ProfileContext,
  ProfileContextProps,
  Ticket,
} from '../../../context/ProfileContext';
import { useNavigate, useParams } from 'react-router-dom';
import Sidebar from '../../../components/ConsumerSidebar/ConsumerSidebar';
import './TicketDetails.css';
import LeftArrow from '../../../assets/Left 1.svg';
import { ReactComponent as ProfileIcon } from '../../../assets/Ticket Profile 1.svg';
import { getStage, getTicketById } from '../../../services/NetworkServices';
import { storeStageNumber } from '../../../utils/auth-token-utils/cookie';
import { Typography, Box, Container, AppBar, Toolbar } from '@mui/material';
import LogoutPopup from '../../../components/Inputs/LogoutPopup';
import TemporaryDrawer from '../../../components/TemporaryDrawer/TemporaryDrawer';

const TicketDetails: React.FC = () => {
  const { showLogoutPopup } = useContext(ProfileContext) as ProfileContextProps;
  const { id } = useParams<{ id: string }>();
  const [ticketDetails, setTicketDetails] = React.useState<Ticket>();
  const navigate = useNavigate();
  const [errorMsg, setErrorMsg] = React.useState<string>('');
  // let [ticket] = ticketsList.filter((ticket: Ticket) => ticket._id === id);
  // console.log("ticket is ", ticket);

  useEffect(() => {
    const fetchStageDetails = async () => {
      try {
        console.log('inside use effect');
        const response = await getStage();
        const data = await response.data;
        if (data) {
          console.log('stage is', data.data.stage);
          const stage = data.data.stage;
          storeStageNumber(stage);
          if (stage === '1') {
            navigate('/participant/createProfile');
          }
          if (stage === '2') {
            navigate('/participant/inviteBabysitter');
          }
          if (stage === '3') {
            navigate('/participant/selectplan');
          }
        }
      } catch (error) {
        console.error('Error fetching profile details:', error);
      }
    };
    fetchStageDetails();
  }, [navigate]);

  useEffect(() => {
    const fetchTicketDetailsById = async () => {
      try {
        if (id) {
          const response = await getTicketById(id);
          const data = await response.data;
          console.log('data is', data);
          if (data) {
            console.log('success');
            setTicketDetails(data.data.ticket);
            //  setApiStatus(ApiStatus.SUCCESS);
          }
        } else {
          setErrorMsg('Ticket ID is missing.');
        }
      } catch (error: any) {
        console.log('error is ', error);
        console.log('error is ', error.response?.data.error?.message);
        //  setApiStatus(ApiStatus.FAILURE);
        setErrorMsg(
          error.response?.data?.error?.message ||
            'Something went wrong. Please try again.',
        );
      }
    };
    fetchTicketDetailsById();
  }, []);

  const handlenavigation = () => {
    navigate('/participant/support');
  };

  const handleBackClick = () => {
    navigate('/participant/dashboard');
  };
  return (
    <>
      {showLogoutPopup && <div className="backdrop"> </div>}
      <Box className="ticket-details-container">
        <Box className="account-details">
          <Box
            sx={{
              display: { xs: 'block', sm: 'flex' },
              height: { xs: '100%', sm: '100vh' },
              overflow: { xs: 'auto', sm: 'hidden' },
            }}
          >
            <AppBar
              position="static"
              sx={{
                display: { xs: 'block', sm: 'none' },
                backgroundColor: 'black',
              }}
            >
              <Toolbar sx={{ background: 'black' }}>
                <TemporaryDrawer />
              </Toolbar>
            </AppBar>
            <Box
              sx={{
                display: { xs: 'none', sm: 'flex' },
                width: { xs: '0%', sm: '35%', md: '28%' },
                justifyContent: 'space-between',
                flexDirection: 'column',
              }}
            >
              <Box
                sx={{
                  height: '100%',
                  marginLeft: { sm: 2, md: 14 },
                  marginTop: { sm: 2, md: 4 },
                  marginBottom: { sm: 30, md: 4 },
                }}
              >
                <Sidebar />
              </Box>
            </Box>
            <Box
              sx={{
                width: { xs: '100%', sm: '65%', md: '72%' },
                flexGrow: 1,
                overflow: 'auto',
                height: '100%',
                paddingY: 4,
              }}
            >
              <Container>
                <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                  <img
                    src={LeftArrow}
                    onClick={handleBackClick}
                    className="arrow-sm"
                  />
                </Box>
                <Box className="edit-profile-pic">
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'flex-start',
                      paddingTop: { xs: '10px', lg: '60px' },
                      width: { xs: '100%', sm: '80%', md: '60%' },
                    }}
                  >
                    <Box className="tickets-list">
                      <Box
                        sx={{
                          display: 'flex',
                          gap: '10px',
                          alignItems: 'center',
                        }}
                      >
                        <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                          <img
                            src={LeftArrow}
                            onClick={handlenavigation}
                            alt="Navigate"
                            style={{ marginTop: '-12px' }}
                          />
                        </Box>
                        <Typography
                          variant="h5"
                          sx={{
                            textAlign: 'left',
                            color: 'white',
                            fontFamily: 'Opensans',
                            paddingBottom: '10px',
                          }}
                        >
                          Ticket Details
                        </Typography>
                      </Box>

                      <Box
                        className="ticket"
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'flex-start',
                          width: { md: '400px' },
                          padding: { xs: '10px', sm: '28px' },
                          gap: '7px',
                        }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <Box
                            sx={{
                              minWidth: '30px',
                              minHeight: '30px',
                              backgroundColor: '#171717',
                              borderRadius: '50%',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            <ProfileIcon
                              style={{
                                width: '20px', // Icon size
                                height: '20px',
                                minWidth: '20px',
                                minHeight: '20px',
                              }}
                            />
                          </Box>
                          <Box
                            px={2}
                            sx={{ display: 'flex', flexDirection: 'column' }}
                          >
                            <Typography
                              variant="body1"
                              sx={{
                                fontSize: { xs: '14px', md: '14px' },
                                textAlign: 'left',
                                color: '#FFFFFC',
                                fontWeight: '600',
                              }}
                            >
                              {ticketDetails?.profileId.firstName}{' '}
                              {ticketDetails?.profileId.lastName}
                            </Typography>
                            <Box
                              sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', lg: 'row' },
                                alignItems: { xs: 'flex-start', lg: 'center' },
                              }}
                            >
                              <Typography
                                variant="body2"
                                sx={{
                                  fontSize: { xs: '12px', md: '12px' },
                                  textAlign: 'left',
                                  color: '#535353',
                                }}
                              >
                                {ticketDetails?.userId.email}
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{
                                  fontSize: { xs: '12px', md: '12px' },
                                  textAlign: 'left',
                                  color: '#535353',
                                }}
                              >
                                <Box
                                  component="span"
                                  sx={{
                                    display: {
                                      xs: 'none',
                                      sm: 'none',
                                      md: 'none',
                                      lg: 'inline',
                                    },
                                  }}
                                >
                                  {'\u00A0'}
                                  {'\u00A0'}
                                  {'\u00A0'}
                                </Box>
                                +1 {ticketDetails?.profileId.phone}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                        <Typography
                          variant="body1"
                          sx={{
                            color: '#DFDFDF',
                            marginBottom: '3vh',
                            fontWeight: '400',
                            marginTop: '3vh',
                            pt: '10px',
                            textAlign: 'left',
                            overflow: 'hidden', // Hides overflowed text

                            wordWrap: 'break-word', // Ensures long words wrap within the box
                          }}
                        >
                          {ticketDetails?.description}
                        </Typography>
                        {ticketDetails?.supportQueryImage && (
                          <img
                            src={ticketDetails?.supportQueryImage}
                            alt="Support Query"
                            className="query-image"
                          />
                        )}
                        {showLogoutPopup && <LogoutPopup />}
                        {ticketDetails?.responseText && (
                          <Box>
                            <Box
                              gap={1}
                              sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                              }}
                            >
                              <Box
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                }}
                              >
                                <Box
                                  sx={{
                                    minWidth: '30px',
                                    minHeight: '30px',
                                    backgroundColor: '#171717',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                  }}
                                >
                                  <ProfileIcon
                                    style={{
                                      width: '20px', // Icon size
                                      height: '20px',
                                      minWidth: '20px',
                                      minHeight: '20px',
                                    }}
                                  />
                                </Box>
                                <Box
                                  sx={{
                                    display: 'flex',
                                    flexDirection: { xs: 'column', lg: 'row' },
                                  }}
                                >
                                  <Box
                                    px={2}
                                    sx={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      justifyContent: 'start',
                                    }}
                                  >
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        fontSize: { xs: '14px', md: '14px' },
                                        textAlign: 'left',
                                        color: '#FFFFFC',
                                        fontWeight: '600',
                                      }}
                                    >
                                      Admin
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        fontSize: {
                                          xs: '12px',
                                          sm: '12px',
                                          md: '12px',
                                        },
                                        textAlign: 'left',
                                        color: '#535353',
                                      }}
                                    >
                                      {ticketDetails?.adminId?.email}
                                    </Typography>
                                  </Box>
                                  <Box>
                                    <Typography
                                      variant="body2"
                                      sx={{
                                        px: { xs: 2, lg: '0' },
                                        fontSize: { xs: '12px' },
                                        textAlign: 'left',
                                        color: '#535353',
                                      }}
                                    >
                                      Replied to you
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                            <Typography
                              variant="body1"
                              sx={{
                                color: '#DFDFDF',
                                marginBottom: '3vh',
                                fontWeight: '400',
                                marginTop: '3vh',
                                pt: '10px',
                                textAlign: 'left',
                                overflow: 'hidden', // Hides overflowed text

                                wordWrap: 'break-word', // Ensures long words wrap within the box
                              }}
                            >
                              {ticketDetails?.responseText}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Container>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default TicketDetails;
